import { render, staticRenderFns } from "./NavigationDrawerManutencaoDetalhe.vue?vue&type=template&id=a64c9570&scoped=true&"
import script from "./NavigationDrawerManutencaoDetalhe.vue?vue&type=script&lang=ts&"
export * from "./NavigationDrawerManutencaoDetalhe.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationDrawerManutencaoDetalhe.vue?vue&type=style&index=0&id=a64c9570&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64c9570",
  null
  
)

export default component.exports